export default __webpack_public_path__ + "static/media/CNo.76-4.cc73fe34.jpg";